import { memo, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PaymentContext, usePaymnetContext } from "../..";
import Loader from "../../Loader/Loader";
import { checkoutBank, fetchPaymentPartnersAPI, verifyBank } from "../../payements/apiSercive";
import { getQueryStringValue, IPaymentPartner, PREVIEW_MODE } from "../../payements/common";
import { PaymentAmount, PaymentButton, PaymentVendor } from "../../payements/payment.card/payment.card";
import fromik, { useFormik } from "formik";
import * as yup from "yup"
import "./add.bank.scss";
import ProgressBar from "../../components/ProgressBar/ProgressBar";

interface AddBankProps {
    selectedPayment?: any;
    onPaymentSelect: (item: any) => void;
}

const AddBank = memo(({ selectedPayment, onPaymentSelect }: AddBankProps) => {
    const { t } = useTranslation();
    const { state, update } = usePaymnetContext();
    const [loading, setLoading] = useState<boolean>(false)
    const formik = useFormik({
        initialValues: {
            accountName: "",
            accountNo: "",
            mobileNo: "",
            referenceId: "",
            step: 1
        },
        validationSchema: yup.object().shape({
            accountName: yup.string().required(t("requiredField")).max(50, t("maxLimit", { value: "Account Name" })),
            accountNo: yup.string().required(t("requiredField")),
            mobileNo: yup.string().required(t("requiredField"))
                .matches(/^(0658)\d{6}$/, t("phoneForBank", { value: "0658xxxxxx" })),
            step: yup.number(),
        }),
        onSubmit: (values, actions) => {
            setLoading(true)
            const modal: any = {
                "amount": state.paymentDetail?.amount,
                "currencyCode": selectedPayment?.currency,
                "source": selectedPayment?.source || "Lipia Link",
                "merchantAccountNumber": values.accountNo,
                "merchantMobileNumber": values.mobileNo,
                "merchantName": values.accountName,
                "provider": selectedPayment?.partnerName,
                "referenceId": state.paymentDetail?.externalId,
                "additionalProperties": {
                    "shop": selectedPayment?.vendorName
                }
            }
            verifyBank(modal).then(resp => {
                if (resp.success) {
                    actions.setFieldValue("referenceId", resp.data.properties.ReferenceID)
                    actions.setFieldValue("step", 2)
                } else {
                    update({
                        ...state,
                        success: true,
                        systemMessage: {
                            ...state.systemMessage,
                            show: true,
                            title: t("genralErrorTitle"),
                            message: resp.msg,
                        }
                    });
                }
                setLoading(false)
            }).catch((error) => {
                setLoading(false)
                update({
                    ...state,
                    success: false,
                    systemMessage: {
                        ...state.systemMessage,
                        show: true,
                        title: error?.code,
                        message: error.message
                    }
                });
            })

        }
    })
    const formik1 = useFormik({
        initialValues: {
            otp: "",
        },
        validationSchema: yup.object().shape({
            otp: yup.number().typeError(t("mustBeNumber")).required(t("requiredField"))
        }),
        onSubmit: (values, actions) => {
            if (formik.values.step === 3) {
                setLoading(true)
                const modal: any = {
                    "amount": state.paymentDetail?.amount,
                    "currencyCode": selectedPayment?.currency,
                    "source": selectedPayment?.source || "Lipia Link",
                    "merchantAccountNumber": formik.values.accountNo,
                    "merchantMobileNumber": formik.values.mobileNo,
                    "merchantName": formik.values.accountName,
                    "provider": selectedPayment?.partnerName,
                    "referenceId": state.paymentDetail?.externalId,
                    "otp": values.otp,
                    "verificationId": formik.values.referenceId,
                }
                checkoutBank(modal).then(resp => {
                    if (resp.success) {
                        return window.location.href = `/status?id=${resp.data.properties.ReferenceID}&provider=${selectedPayment?.provider}`
                    } else {
                        update({
                            ...state,
                            success: true,
                            systemMessage: {
                                ...state.systemMessage,
                                show: true,
                                title: t("genralErrorTitle"),
                                message: resp.msg,
                            }
                        });
                    }
                    setLoading(false)
                }).catch((error) => {
                    setLoading(false)
                    update({
                        ...state,
                        success: false,
                        systemMessage: {
                            ...state.systemMessage,
                            show: true,
                            title: error?.code,
                            message: error.message
                        }
                    });
                })
            } else {
                formik.setFieldValue("step", 3)
            }
        }
    })

    if (loading) return <Loader />

    return <>
        <PaymentVendor />
        <PaymentAmount />
        <div>
            <img
                src={selectedPayment.logoUrl || "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/default-mno.svg"}
            />
        </div>
        <ProgressBar step={formik.values.step} />
        <hr className="line" />
        <form className="bank-form" onSubmit={(e) => { e.preventDefault() }}>
            {formik.values.step === 1 && <>
                <div className="detail">{t("bankDetailTitle")}</div>
                <Input
                    id="accountName"
                    name="accountName"
                    label={t("accountName")}
                    value={formik.values.accountName}
                    error={(formik.touched.accountName && formik.errors.accountName) ? formik.errors.accountName : ""}
                    onChange={formik.handleChange}
                />
                <Input
                    id="accountNo"
                    name="accountNo"
                    label={t("accountNo") + "."}
                    value={formik.values.accountNo}
                    error={(formik.touched.accountNo && formik.errors.accountNo) ? formik.errors.accountNo : ""}
                    onChange={formik.handleChange}
                />
                <Input
                    id="mobileNo"
                    name="mobileNo"
                    label={t("mobileNo") + "."}
                    value={formik.values.mobileNo}
                    error={(formik.touched.mobileNo && formik.errors.mobileNo) ? formik.errors.mobileNo : ""}
                    onChange={formik.handleChange}
                />
            </>}
            {formik.values.step === 2 && <div className="bank-form">
                <Input
                    id="otp"
                    name="otp"
                    label={t("enterOTPLabel")}
                    value={formik1.values.otp}
                    error={(formik1.touched.otp && formik1.errors.otp) ? formik1.errors.otp : ""}
                    onChange={formik1.handleChange}
                />
                <div className="otp-msg-cnt">
                    <div></div>
                    <div className="enter-otp">{t("enterOTP")}</div>
                    <div></div>
                    {/* <label className="otp-counter">89 seconds</label> */}
                </div>

                {/* <div className="otp-resend-cnt">
                    <span className="message">{`${t("didntReceiveOTP")}?`}</span>
                    <button className="resend">{t("resendOTP")}</button>
                </div> */}
            </div>
            }

            {
                formik.values.step === 3 && <div>
                    <div className="detail">{t("bankSummary")}</div>

                    <div className="info">
                        <div className="info-label">{t("accountName")}:</div>
                        <div className="info-value">{formik.values.accountName}</div>
                    </div>

                    <div className="info">
                        <div className="info-label">{t("accountNo")}:</div>
                        <div className="info-value">{formik.values.accountNo}</div>
                    </div>
                </div>
            }
            <div>
                <button
                    className="payment-btn"
                    onClick={() => formik.values.step === 1 ? formik.handleSubmit() : formik1.handleSubmit()}
                >
                    <span>{formik.values.step === 3 ? t("makePayment") : t("procceed")}</span>

                    <img
                        src={`https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/${formik.values.step === 3 ? "shield-tick-outline" : "arrow-right"}.svg`}
                        alt="arrow-right"
                        className="icon"
                    />
                </button>
            </div>
        </form>

    </>
});


const Input = ({ id, name, label, error, value, onChange, ...rest }: { id?: string; name?: string; label?: string; error?: string; value: string; onChange: (e: any) => void, rest?: any }) => {
    return <label className="form-field">
        <span className="field-label">{label}</span>
        <input id={id} name={name} className="field-input" value={value} onChange={onChange} type="input" {...rest} />
        {error && <span className="field-error">{error}</span>}
    </label>
}

export default AddBank;
